<template>
  <div class="wrapper">
    <h1>My Content</h1>
    <template>
      <!-- filters -->
      <!-- FIXME: Refactir filters into a separate component -->
      <div class="table-options">
        <span>Filters:</span>
        <div class="select-container select-container--no-label">
          <select v-model="statusFilter" data-cy="status-filter">
            <option default value="">All Statuses</option>
            <option value="Draft">Draft</option>
            <option value="Pending Review">Pending Review</option>
            <option value="Revision Needed">Revision Needed</option>
            <option value="Approved">Approved</option>
            <option value="Exported">Exported</option>
            <option value="Live">Live (discontinued)</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select v-model="monthFilter" data-cy="months-filter">
            <option value="-1">All Months</option>
            <option v-for="month in monthList" v-bind:key="month.id" :value="month.id">{{ month.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
      </div>
      <!-- content -->
      <div v-if="isLoading" class="loading" data-cy="spinner"></div>

      <div v-if="Object.keys(userContent).length">
        <div v-for="(contentType, index) in userContent" v-bind:key="index">
          <h3 :data-cy="`content-title-${index}`">{{ index }}</h3>
          <div class="table table--5-columns">
            <div class="table__headers">
              <div class="table__header">Title</div>
              <div class="table__header">Type</div>
              <div class="table__header">Created date</div>
              <div class="table__header">Status</div>
              <div></div>
            </div>
            <div v-if="contentType.length === 0">
              <div class="table__row table__row--empty">
                <div class="table__cell">
                  Your content will appear here
                </div>
              </div>
            </div>
            <template v-for="data in contentType">
              <router-link :to="data.path + data.id" v-bind:key="data.id" class="table__row">
                <div class="table__cell">{{ data.title }}</div>
                <div class="table__cell">{{ data.type }}</div>
                <div class="table__cell">
                  {{ submitDateFormatted(data.createdAt) }}
                </div>
                <div class="table__cell">{{ data.status }}</div>
                <!-- prettier-ignore -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
              </router-link>
            </template>
          </div>
          <div v-show="!contentType[contentType.length - 1].isLast" class="button__container">
            <button class="button--link" @click="loadMoreContent(index)" :data-cy="`see-more-${index}`">See more...</button>
          </div>
        </div>
      </div>
      <div v-else>
        <span>You have not created any content yet</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'overview',
  data() {
    return {
      userDataList: [],
      isLoading: true,
      statusFilter: '',
      monthFilter: -1,
    }
  },
  methods: {
    ...mapActions(['fetchUserContent', 'fetchMoreContent']),
    ...mapMutations({ updatePage: 'SET_CURRENT_PAGE' }),
    async getUserDataList() {
      await this.fetchUserContent()
      this.isLoading = false
    },
    submitDateFormatted(submitDate) {
      let date = new Date(submitDate)
      return date.toLocaleString('da-DK')
    },
    async loadMoreContent(contentTypeName) {
      this.isLoading = true
      await this.fetchMoreContent({ contentTypeName, filters: { statusFilter: this.statusFilter, monthFilter: this.monthFilter } })
      this.isLoading = false
    },
  },
  mounted: async function() {
    await this.getUserDataList()

    if (this.user.data.firestore.isAdmin) {
      this.$router.push('/overview/review')
    }
  },

  watch: {
    statusFilter: async function(val) {
      this.statusFilter = val
      await this.fetchUserContent({ statusFilter: this.statusFilter, monthFilter: this.monthFilter })
    },
    monthFilter: async function(val) {
      this.monthFilter = val
      await this.fetchUserContent({ statusFilter: this.statusFilter, monthFilter: this.monthFilter })
    },
  },

  computed: {
    ...mapGetters(['monthList', 'user', 'userContent', 'contentTypes']),
  },
}
</script>
<style lang="css">
.pagination {
  display: flex;
  justify-content: center;
  list-style: none;
  font-weight: 600;
}
.page-item {
  margin: 0 20px 0 20px;
}

.active {
  color: var(--color-state);
}
</style>

<style lang="scss" scoped>
@import '@/assets/shared-styles/table.scss';
@import '@/assets/shared-styles/select.scss';
@import '@/assets/shared-styles/button.scss';
@import '@/assets/shared-styles/loader.scss';

.wrapper {
  display: grid;
  gap: 1.5rem;
  align-items: start;
  padding: 2rem 2rem;
}

.content {
  .header {
    font-weight: 600;
  }
  .header,
  .items {
    display: grid;
    grid-template-areas:
      'title status'
      'fetching fetching';
    grid-template-columns: minmax(auto, 300px) auto;
    .title {
      grid-area: title;
      a {
        color: var(--color-cta);
      }
    }
    .status {
      grid-area: status;
      min-width: 10rem;
    }
    .fetching {
      grid-area: fetching;
    }
  }
}

.button__container {
  display: flex;
  justify-content: center;
  margin-top: 1%;
}
</style>
